/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from "@msdyn365-commerce/core";
import { updateCaseAsync } from "../proxy/britax-claims-proxy/DataActionExtension.g";
import { UpdateCaseExtensionClass } from "../proxy/britax-claims-proxy/DataServiceEntities.g";
/**
 * Updatecase Input Action
 */
var caseContent: UpdateCaseExtensionClass[];
var incidentId: any;
export class UpdatecaseInput implements Msdyn365.IActionInput {
  // TODO: Construct the input needed to run the action
  constructor(attachments: any, caseId: any) {
    caseContent = attachments;
    incidentId = caseId;
  }

  // TODO: Determine if the results of this get action should cache the results and if so provide
  // a cache object type and an appropriate cache key
  public getCacheKey = () => `updateCase`;
  public getCacheObjectType = () => "updateCase";
  public dataCacheType = (): Msdyn365.CacheType => "none";
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IUpdatecaseData {
  text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
  args: Msdyn365.ICreateActionContext
): Msdyn365.IActionInput => {
  return new UpdatecaseInput("", "");
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: UpdatecaseInput, ctx: Msdyn365.IActionContext) {
  // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
  if (caseContent) {
    for (let i = 0; i < caseContent.length; i++) {
      await updateCaseAsync(
        { callerContext: ctx },
        {
          IncidentId: "/incidents(" + incidentId + ")",
          FileName: caseContent[i].FileName,
          IsDocument: true,
          DocumentBody: caseContent[i].DocumentBody,
        }
      );
    }
  }

  // TODO: Uncomment the below line to get the value from a service
  // const response = await Msdyn365.sendRequest<IUpdatecaseData[]>('/get/example/id/1', 'get');
}

export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<void>>action,
  // TODO: Give your data action a unique id
  id: "Updatecase",
  input: createInput,
  // TODO: Uncomment the below line if this is a meant to be a batched data action
  // isBatched: true
});
